<template>
    <div class="auth-container">
      <img src="@/assets/RiskyPawsLogo.png" alt="RiskyPaws Logo" class="logo" />
  
      <h2 v-if="!codeSent">Reset Password for RiskyPaws: Your Financial Companion</h2>
      <h2 v-else>Enter New Password: RiskyPaws</h2>
  
      <form v-if="!codeSent" @submit.prevent="sendCode">
        <input class="auth-input" type="email" v-model="email" placeholder="Enter your email" required />
        <button class="auth-button" type="submit">Send Reset Code</button>
      </form>
  
      <form v-if="codeSent" @submit.prevent="resetPassword">
        <input class="auth-input" type="text" v-model="code" placeholder="Enter reset code" required />
        <input class="auth-input" type="password" v-model="newPassword" placeholder="Enter new password" required />
        <button class="auth-button" type="submit">Reset Password</button>
      </form>
  
      <p v-if="message" class="success-message">{{ message }}</p>
      <p v-if="error" class="error-message">{{ error }}</p>
    </div>
  </template>
  
  <script>
  import { Auth } from 'aws-amplify';
  
  export default {
    data() {
      return {
        email: '',
        code: '',
        newPassword: '',
        codeSent: false,
        error: '',
        message: '',
      };
    },
    methods: {
      async sendCode() {
        try {
          await Auth.forgotPassword(this.email);
          this.codeSent = true;
          this.message = 'A reset code has been sent to your email. Please enter it below with your new password.';
        } catch (error) {
          this.error = error.message || "An unexpected error occurred";
        }
      },
      async resetPassword() {
        try {
          await Auth.forgotPasswordSubmit(this.email, this.code, this.newPassword);
          this.message = 'Password reset successful. Please log in with your new password.';
          // You can redirect or take other actions here
        } catch (error) {
          this.error = error.message || "Password reset failed";
        }
      },
    },
  };
  </script>


<style scoped>
.auth-container {
  width: 350px;
  margin: auto;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0,0,0,0.1);
  background-color: #C9B6D9 ;
  text-align: center;
}

.auth-input {
  width: calc(100% - 20px);
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

.auth-button, .toggle-button, .google-button {
  width: calc(100% - 20px);
  padding: 12px;
  border: none;
  border-radius: 5px;
  margin-bottom: 20px;
  cursor: pointer;
  font-size: 16px;
}

.auth-button {
  background-color: #4A148C;
  color: white;
}

.toggle-button {
  background-color: #e0e0e0;
}

.google-button {
  background-color: #dd4b39;
  color: white;
}

.error-message {
  color: red;
  margin-bottom: 20px;
}

.logo {
  width: 300px; 
  margin: 5px auto 10px;
  display: block;
}

.success-message {
  color: green;
  margin-bottom: 20px;
}

.amazon-button {
background-color: #4A148C;
color: white;
}

@media (max-width: 600px) {
  .auth-container {
    width: 90%;
    padding: 10px;
  }
  .logo {
    width: 80%;
  }
  /* Other styles for smaller screens */
}
</style>
